import {useEffect} from 'react';

export const useKeyPress = ({
  key: targetKey,
  onKeyDown,
  onKeyUp,
  disabled = false,
}: {
  key: string;
  onKeyDown?: (ev: KeyboardEvent) => void;
  onKeyUp?: (ev: KeyboardEvent) => void;
  disabled?: boolean;
}) => {
  useEffect(() => {
    if (disabled || !onKeyDown) {
      return;
    }
    const downHandler = (ev: KeyboardEvent) => {
      if (ev.key === targetKey) {
        onKeyDown(ev);
      }
    };

    window.addEventListener('keydown', downHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
    };
  }, [targetKey, disabled, onKeyDown]);

  useEffect(() => {
    if (disabled || !onKeyUp) {
      return;
    }
    const upHandler = (ev: KeyboardEvent) => {
      if (ev.key === targetKey) {
        onKeyUp(ev);
      }
    };

    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keyup', upHandler);
    };
  }, [targetKey, disabled, onKeyUp]);
};
